import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { ExclamationTriangleIcon } from "@heroicons/react/24/outline";

const CustomShipmentBannerTotal = ({ cartNumbers,companies,getCompany}) => {
    const [isChecked, setIsChecked] = useState(false);
    const { t } = useTranslation();


    const pairs = cartNumbers.split(',');

    const ids = pairs.map(pair => pair.split('-')[1].trim());

    const cartIds = ids.join(' - ');

    // console.log(cartIds)
  

    // console.log(selectedCompany)
    return (
      <div
        className={`flex w-full items-center justify-between lg:p-1  ${
          isChecked ? "bg-custom-yellow text-black" : "bg-white text-black"
        }`}
      >
        {/* Order Number */}
        <div className="flex items-center gap-1 font-bold">
          <span className="text-[10px] text-gray-800 lg:text-lg">{t("orderNumber")}:</span>
          <span className="text-[10px] text-gray-800 lg:text-base">{cartIds}</span>
        </div>

        {/* Shipping Company */}
        <div className="flex items-center gap-1 lg:gap-2 text-red-500 text-[10px] lg:text-lg">
          <ExclamationTriangleIcon className="w-3 h-3 lg:h-6 lg:w-6" />
          {t("ErrorChooseShippingCompany")}
        </div>
      </div>
    );
  };
  

export default CustomShipmentBannerTotal;
